<template>
  <div
    class="text-separator"
    :class="{ 'has-text': text.length > 0 }"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'TextSeparator',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.text-separator {
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: lowercase;
  font-size: 16px;
  line-height: 19px;
  margin-top: 40px;
  margin-bottom: 40px;
  letter-spacing: 0.1px;
  font-weight: 400;
  @apply text-text-default;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid;
    @apply border-dividers-default;
  }

  &.has-text {
    &:not(:empty)::before {
      margin-right: 30px;
    }
    &:not(:empty)::after {
      margin-left: 30px;
    }
  }

  &.ws {
    margin-top: 16px;
    margin-bottom: 16px;
  }
}
</style>
